module.exports = __webpack_public_path__ + "static/media/vip-blue.21023d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/vip-blue.png
// module id = 1964
// module chunks = 6